import React from "react";

import { Container } from "./styles";

function PT() {
  return (
    <Container className="container" id="pt">
      <iframe
        src={process.env.REACT_APP_PT_DESKTOP}
        id="desktop-pt"
        className="responsive-iframe-desktop"
        title="Importacao_Vinhos_Demonstracao"
        width="600"
        height="373.5"
        frameborder="0"
        allowfullscreen="true"
      />
      <iframe
        src={process.env.REACT_APP_PT_MOBILE}
        id="mobile-pt"
        className="responsive-iframe-mobile"
        title="teste layout vertical"
        width="600"
        height="373.5"
        frameborder="0"
        allowfullscreen="true"
      />
    </Container>
  );
}

export default PT;
